import React from 'react';
import { formatDatetimeToDate } from '../../../../../../js/utils/datetime';
import { readableFileSize } from '../../../../../../js/utils/filesize';
import readableFileName from '../../../../../shared/Quotes/utils/readableFileName';
import readableFileType from '../../../../../shared/Quotes/utils/readableFileType';
import { ItpRfqContextQuery_quotesForRfq as LimitedQuote } from '../../../../context/types/ItpRfqContextQuery';
import styles from '../styles.scss';

type QuotesTableProps = {
  quotesForRfq: LimitedQuote[];
};

export const QuotesTable: React.VFC<QuotesTableProps> = ({ quotesForRfq }) => (
  <table className={styles.itpQuotesTable}>
    <thead>
      <tr>
        <th>Date</th>
        <th>Type</th>
        <th>Size</th>
        <th>Title</th>
      </tr>
    </thead>
    <tbody>
      {quotesForRfq.map(({ id, createdAt, fileName, fileSize }) => (
        <tr key={id}>
          <td>{formatDatetimeToDate(createdAt)}</td>
          <td>{readableFileType(fileName)}</td>
          <td>{readableFileSize(fileSize)}</td>
          <td>{readableFileName(fileName)}</td>
        </tr>
      ))}
    </tbody>
  </table>
);
